<template>
  <div>
    <v-dialog v-model="value" persistent max-width="1200px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Importar colaboradores</span>
          <!-- {{ updatedCollabs.length }}
          <br />
          {{ progressTicsStep3 }}
          <br />
          {{ allCollabs.length }}
          <br />
          {{ isLoadingCollabs }}
          <br />
          {{ totalTicsStep3 }}
          <br />
          {{ totalTicsStep4 }}
          <br />
          {{ currentTicsStep4 }}
          <br />
          {{ progressTicsLoadStep4 }} -->
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-stepper v-model="e1" class="elevation-0">
                <v-stepper-header>
                  <v-stepper-step :complete="e1 > 1" :step="1">
                    Sube tu archivo
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="e1 > 2" :step="2">
                    {{ step2Title }}
                    <!-- <span v-if="!working.validating">{{ modal.text }}</span>
                      <v-progress-circular
                        v-else
                        size="20"
                        indeterminate
                        color="primary"
                      ></v-progress-circular> -->
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="e1 > 3" :step="3">
                    Validar datos
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :step="4">Terminado</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content :step="1">
                    <v-card>
                      <v-card-title class="subheading">
                        Importa tu archivo Excel de tus colaboradores como se
                        muestra en el ejemplo.
                        <a href="examples/lista_ejemplo_colaboradores.xlsx">
                          &nbsp;Descargar
                        </a>
                      </v-card-title>
                      <v-layout row wrap justify-center>
                        <v-flex xs12 class="form-csv text-xs-center">
                          <input
                            @change="fileLoad($event)"
                            id="file_csv_colab"
                            type="file"
                            accept=".xlsx"
                          />
                          <div class="csv-text">
                            <h4 class="center-align">
                              Arrastra tu archivo Excel aquí
                            </h4>
                            <h5 id="csv-success">
                              O
                              <u style="color: red">
                                <span style="color: red">selecciona</span>
                              </u>
                              el archivo
                            </h5>
                          </div>
                        </v-flex>
                        <v-expand-transition>
                          <v-flex
                            v-show="working.loading"
                            mt-3
                            xs12
                            class="text-xs-center"
                          >
                            <v-progress-circular indeterminate color="primary">
                            </v-progress-circular>
                          </v-flex>
                        </v-expand-transition>
                        <!-- <v-expand-transition>
                            <v-flex
                              v-show="working.loading"
                              mt-3
                              xs12
                              class="text-xs-center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              ></v-progress-circular>
                            </v-flex>
                          </v-expand-transition>
                          <v-expand-transition>
                            <v-flex
                              v-show="flags.status == 200"
                              mt-3
                              xs12
                              class="text-xs-center"
                            >
                              <v-icon style="vertical-align: bottom" color="green"
                                >check</v-icon
                              >Archivo válido
                            </v-flex>
                          </v-expand-transition>
                          <v-expand-transition>
                            <v-flex
                              v-show="flags.status == 201"
                              mt-3
                              xs12
                              class="text-xs-center"
                            >
                              <v-icon
                                style="vertical-align: bottom"
                                color="orange"
                                >warning</v-icon
                              >Archivo con registros erróneos pero aún importable
                            </v-flex>
                          </v-expand-transition>
                          <v-expand-transition>
                            <v-flex
                              v-show="flags.status == 404"
                              mt-3
                              xs12
                              class="text-xs-center"
                            >
                              <v-icon style="vertical-align: bottom" color="red"
                                >clear</v-icon
                              >El archivo no es válido
                            </v-flex>
                          </v-expand-transition> -->
                        <v-expand-transition>
                          <v-flex
                            v-show="
                              fileFlagOption ===
                              FILE_FLAG_OPTIONS.incorrectFormat
                            "
                            mt-3
                            xs12
                            class="text-xs-center"
                          >
                            <v-icon style="vertical-align: bottom" color="red">
                              clear
                            </v-icon>
                            El formato del archivo no es correcto; descarga el
                            ejemplo para mayor información
                          </v-flex>
                        </v-expand-transition>
                        <v-expand-transition>
                          <v-flex
                            v-show="
                              fileFlagOption === FILE_FLAG_OPTIONS.errorOnItems
                            "
                            mt-3
                            xs12
                            class="text-xs-center"
                          >
                            <v-icon
                              style="vertical-align: bottom"
                              color="orange"
                            >
                              warning
                            </v-icon>
                            Archivo con registros erróneos pero aún importable
                          </v-flex>
                        </v-expand-transition>
                        <v-expand-transition>
                          <v-flex
                            v-show="
                              fileFlagOption === FILE_FLAG_OPTIONS.correctFormat
                            "
                            mt-3
                            xs12
                            class="text-xs-center"
                          >
                            <v-icon
                              style="vertical-align: bottom"
                              color="green"
                            >
                              check
                            </v-icon>
                            Archivo válido
                          </v-flex>
                        </v-expand-transition>
                      </v-layout>
                      <v-layout row wrap justify-center>
                        <v-flex xs12>
                          <v-checkbox
                            v-model="collabOptionCheckUpdate"
                            color="primary"
                            id="promote"
                            label="Actualizar información de colaboradores"
                            hide-details
                          />
                          <v-checkbox
                            v-model="collabOptionCheckDelete"
                            class="mb-3"
                            color="primary"
                            label="Eliminar colaboradores que no se incluyan en el listado"
                            hide-details
                          />
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-stepper-content>

                  <v-stepper-content :step="2">
                    <v-card height="500px">
                      <v-data-table
                        :rows-per-page-items="[50, 100]"
                        :headers="headers"
                        :items="errorItems"
                        :loading="working.validating"
                        rows-per-page-text="Registros por página"
                      >
                        <v-progress-linear
                          v-slot:progress
                          color="primary"
                          indeterminate
                        ></v-progress-linear>
                        <template v-slot:pageText="props"
                          >{{ props.pageStart }} - {{ props.pageStop }} de
                          {{ props.itemsLength }}</template
                        >
                        <template v-slot:headers="props">
                          <tr>
                            <th
                              style="
                                width: 200px;
                                max-width: 220px;
                                min-width: 220px;
                              "
                              v-for="header of props.headers"
                              :key="header.text"
                            >
                              {{ header.text }}
                            </th>
                          </tr>
                        </template>
                        <template v-slot:items="props">
                          <td
                            style="
                              width: 205px;
                              max-width: 205px;
                              min-width: 205px;
                            "
                            :class="
                              props.item.hasError(COLLABORATOR_ERRORS.firstName)
                                ? 'custom_field_error_massive_upload'
                                : ''
                            "
                            :data-error="
                              props.item.getError(COLLABORATOR_ERRORS.firstName)
                            "
                          >
                            <v-edit-dialog
                              lazy
                              :class="
                                props.item.hasError(
                                  COLLABORATOR_ERRORS.firstName
                                )
                                  ? 'custom_error _relative'
                                  : '_custom_full_width _relative'
                              "
                            >
                              {{ props.item.firstName }}
                              <v-icon class="no-border">edit</v-icon>
                              <template v-slot:input>
                                <v-text-field
                                  v-model="props.item.firstName"
                                  label="Nombre"
                                ></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td
                            style="
                              width: 205px;
                              max-width: 205px;
                              min-width: 205px;
                            "
                            :class="
                              props.item.hasError(COLLABORATOR_ERRORS.lastName)
                                ? 'custom_field_error_massive_upload'
                                : ''
                            "
                            :data-error="
                              props.item.getError(COLLABORATOR_ERRORS.lastName)
                            "
                          >
                            <v-edit-dialog
                              lazy
                              :class="
                                props.item.hasError(
                                  COLLABORATOR_ERRORS.lastName
                                )
                                  ? 'custom_error _relative'
                                  : '_custom_full_width _relative'
                              "
                            >
                              {{ props.item.lastName }}
                              <v-icon class="no-border">edit</v-icon>
                              <template v-slot:input>
                                <v-text-field
                                  v-model="props.item.lastName"
                                  label="Apellido"
                                ></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td
                            style="
                              width: 250px;
                              max-width: 250px;
                              min-width: 250px;
                            "
                            :class="
                              props.item.hasError(COLLABORATOR_ERRORS.email)
                                ? 'custom_field_error_massive_upload'
                                : ''
                            "
                            :data-error="
                              props.item.getError(COLLABORATOR_ERRORS.email)
                            "
                          >
                            <v-edit-dialog
                              lazy
                              :class="
                                props.item.hasError(COLLABORATOR_ERRORS.email)
                                  ? 'custom_error _relative'
                                  : '_custom_full_width _relative'
                              "
                            >
                              {{ props.item.email }}
                              <v-icon class="no-border">edit</v-icon>
                              <template v-slot:input>
                                <v-text-field
                                  v-model="props.item.email"
                                  label="Correo"
                                ></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td
                            style="
                              width: 250px;
                              max-width: 250px;
                              min-width: 250px;
                            "
                            :class="
                              props.item.hasError(
                                COLLABORATOR_ERRORS.updatedEmail
                              )
                                ? 'custom_field_error_massive_upload'
                                : ''
                            "
                            :data-error="
                              props.item.getError(
                                COLLABORATOR_ERRORS.updatedEmail
                              )
                            "
                          >
                            <v-edit-dialog
                              lazy
                              :class="
                                props.item.hasError(
                                  COLLABORATOR_ERRORS.updatedEmail
                                )
                                  ? 'custom_error _relative'
                                  : '_custom_full_width _relative'
                              "
                            >
                              {{ props.item.updatedEmail }}
                              <v-icon class="no-border">edit</v-icon>
                              <template v-slot:input>
                                <v-text-field
                                  v-model="props.item.updatedEmail"
                                  label="Correo Nuevo"
                                ></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td
                            style="
                              width: 200px;
                              max-width: 220px;
                              min-width: 220px;
                            "
                            :class="
                              props.item.hasError(COLLABORATOR_ERRORS.role)
                                ? 'custom_field_error_massive_upload'
                                : ''
                            "
                            :data-error="
                              props.item.getError(COLLABORATOR_ERRORS.role)
                            "
                          >
                            <v-edit-dialog
                              lazy
                              :class="
                                props.item.hasError(COLLABORATOR_ERRORS.role)
                                  ? 'custom_error _relative'
                                  : '_custom_full_width _relative'
                              "
                            >
                              {{ props.item.webRole.name }}
                              <v-icon class="no-border">edit</v-icon>
                              <template v-slot:input>
                                <v-select
                                  close-on-complete
                                  item-text="name"
                                  :item-value="(e) => e"
                                  v-model="props.item.webRole"
                                  :items="roles"
                                  label="Roles"
                                  solo
                                  flat
                                  hide-details
                                >
                                </v-select>
                              </template>
                            </v-edit-dialog>
                          </td>
                          <td
                            style="
                              width: 200px;
                              max-width: 220px;
                              min-width: 220px;
                            "
                            class="text-xs-left"
                          >
                            {{ props.item.errorMessage }}
                          </td>
                          <!-- <td
                              style="
                                width: 200px;
                                max-width: 220px;
                                min-width: 220px;
                              "
                              v-if="excel2jsonFail.length > 0"
                              class="text-xs-right"
                            >
                              {{ props.item.Error }}
                            </td> -->
                          <!-- <td
                              v-else
                              style="
                                width: 200px;
                                max-width: 220px;
                                min-width: 220px;
                              "
                            ></td> -->
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <v-card>
                      <v-layout row wrap justify-center>
                        <div
                          style="
                            height: 28px;
                            width: 100%;
                            border: 1px solid #aaa;
                            border-radius: 13px;
                            padding: 3px;
                            text-align: -webkit-center;
                            color: white;
                          "
                        >
                          <div
                            class="bar"
                            :style="{
                              width:
                                4 + (progressTicsStep3 * (100 - 4)) / 100 + '%',
                            }"
                          >
                            <span class="spb">
                              {{ progressTicsStep3.toFixed(2) }}%
                            </span>
                          </div>
                        </div>

                        <v-spacer></v-spacer>
                        <v-flex xs12 sm8>
                          <v-text-field
                            v-model="searchUpdated"
                            label="Buscar"
                            outline
                            height="47px"
                            @change="getUpdatedItems()"
                          />
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-select
                            v-model="optionCollabValidatedSelected"
                            :items="optionCollabValidated"
                            label="Estatus"
                            outline
                            height="47px"
                            @change="getUpdatedItems()"
                          ></v-select>
                        </v-flex>
                        <v-data-table
                          style="width: 100%"
                          :headers="headersUpdated"
                          :items="updatedCollabs"
                          :total-items="totalItemsUpgrade"
                          :loading="loadingUpgrade"
                          :pagination.sync="paginationUpgrade"
                          rows-per-page-text="Registros por página"
                          no-results-text="No se encontraron coincidencias"
                          :rows-per-page-items="[50, 100]"
                        >
                          <!-- <template v-slot:headers="props">
                                <tr>
                                  <th
                                    v-for="header of props.headers"
                                    :key="header.value"
                                  >
                                    {{ header.text }}
                                  </th>
                                </tr>
                              </template> -->
                          <template v-slot:items="props">
                            <td>{{ props.item.firstName }}</td>
                            <td>{{ props.item.lastName }}</td>
                            <td>{{ props.item.email }}</td>
                            <td>{{ props.item.updatedEmail }}</td>
                            <td>{{ props.item.webRole.name }}</td>
                            <td
                              :style="`color:${
                                getUpdatedOption(props.item.status).color
                              };`"
                            >
                              {{ getUpdatedOption(props.item.status).text }}
                            </td>
                            <td>
                              {{ getPosssibleErrors(props.item.errors) }}
                            </td>
                            <td>
                              <v-btn flat fab @click="editCollab(props.item)">
                                <v-icon class="no-border">edit_note</v-icon>
                              </v-btn>
                            </td>
                          </template>
                        </v-data-table>
                      </v-layout>

                      <!-- <v-layout row wrap justify-center>
                          º
                          <v-flex xs12 class="text-xs-center">
                            <h1>{{ modal.title }}</h1>
                            <v-alert
                              style="border-radius: 33px"
                              :value="true"
                              :type="flags.status == 201 ? 'warning' : 'success'"
                              >{{ modal.message }}</v-alert
                            >
                          </v-flex>
                        </v-layout> -->
                    </v-card>
                  </v-stepper-content>
                  <v-stepper-content step="4">
                    <v-card>
                      <v-layout row wrap justify-center>
                        <div
                          style="
                            height: 28px;
                            width: 100%;
                            border: 1px solid #aaa;
                            border-radius: 13px;
                            padding: 3px;
                            text-align: -webkit-center;
                            color: white;
                          "
                        >
                          <div
                            class="bar"
                            :style="{
                              width: progressTicsLoadStep4 + '%',
                            }"
                          >
                            <span class="spb">
                              {{ progressTicsLoadStep4.toFixed(2) }}%
                            </span>
                          </div>
                        </div>
                        <div
                          v-if="
                            progressTicsLoadStep4 === 100 &&
                            errorOnStep4 === false
                          "
                        >
                          <v-flex xs12 class="text-xs-center">
                            <h1>Importación finalizada</h1>
                            <v-alert
                              style="border-radius: 33px"
                              :value="true"
                              type="success"
                            >
                              La importación se completo correctamente, puedes
                              verificar los registros en sus secciones
                              correspondientes
                            </v-alert>
                          </v-flex>
                        </div>
                        <div v-if="errorOnStep4">
                          <v-flex xs12 class="text-xs-center">
                            <h1>Error en la importación</h1>
                            <v-alert
                              style="border-radius: 33px"
                              :value="true"
                              type="error"
                            >
                              La importación no se completo correctamente,
                              puedes verificar los registros en sus secciones
                              correspondientes
                            </v-alert>
                          </v-flex>
                        </div>
                      </v-layout>
                    </v-card>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="isValidBackBtn()"
            icon
            color="primary"
            @click="back"
          >
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="isValidCancelBtn()" flat small @click="close">
            Cancelar
          </v-btn>
          <v-btn color="primary" v-if="e1 === 2" flat small @click="revalidate">
            Validar
          </v-btn>
          <!-- <v-btn
              v-if="e1 == 2 && modal.text == 'Corrección de errores'"
              color="primary"
              small
              @click="next"
            >
              Validar
            </v-btn> -->
          <!-- <v-btn
              v-if="e1 == 3 && flags.status == 201"
              color="primary"
              @click="download"
            >
              Descargar
            </v-btn> -->
          <v-btn
            v-if="e1 === 4 && progressTicsLoadStep4 === 100"
            @click="close"
            flat
          >
            Terminar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="e1 === 3"
            :disabled="isLoadingCollabs"
            flat
            color="primary"
            @click="confirmBtn"
          >
            Cargar
          </v-btn>
          <v-btn
            v-if="e1 !== 3"
            :disabled="isValidNextBtn()"
            color="primary"
            icon
            @click="next()"
          >
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogAlert
      v-model="dialog.show"
      :title="dialog.title"
      :description="dialog.message"
      :ok-text="dialog.okText"
    >
    </DialogAlert>
    <ConfirmMail
      :value="confirm.value"
      :title="confirm.title"
      :description="confirm.description"
      v-on:desition="desitionLink"
    ></ConfirmMail>
    <EditCollab
      v-model="modalEditCollab.show"
      :roles="roles"
      :collaborator="modalEditCollab.selectedCollab"
      @updatedCollab="onUpdatedCollab"
    />
    <StatusCount
      v-model="modalStatistics.show"
      :file-id="modalStatistics.fileId"
      @completeUpdateCollabs="onCompleteUpdateCollabs"
      class="'position-no"
      @total="onTotal"
    />
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { funciones } from '../../Mixins/Funciones'
import {
  COLLABORATOR_ERRORS,
  CollaboratorModel,
  FILE_FLAG_OPTIONS,
  MASSIVE_UPLOAD_UPGRADE_RESPONSE,
  loadCollaborator,
  validateParsedCollaborators,
} from '../../Mixins/massiveUpload.js'
import DialogAlert from '../Dialogs/Alert.vue'
import ConfirmMail from '../Dialogs/ConfirmMails.vue'
import StatusCount from './importCollabs/collabStatistics.vue'
import EditCollab from './importCollabs/editCollab.vue'

export default {
  props: ['value', 'roles'],
  mixins: [funciones],
  components: {
    ConfirmMail,
    DialogAlert,
    EditCollab,
    StatusCount,
  },
  data: () => ({
    errorOnStep4: false,
    searchUpdated: '',
    optionCollabValidated: [
      { text: 'Todos', value: '' },
      { text: 'Alta', value: 'NEW', color: 'green' },
      { text: 'Actualización', value: 'UPGRADE', color: 'orange' },
      { text: 'Baja', value: 'REMOVE', color: 'red' },
      { text: 'Sin Cambios', value: 'UNCHANGED', color: '' },
      { text: 'Con Errores', value: 'SKIPPED', color: '' },
    ],
    optionCollabValidatedSelected: undefined,
    step2Title: 'Validar datos',
    dialog: {
      show: false,
      title: '',
      message: '',
      okText: '',
    },
    collabOptionCheckUpdate: false,
    collabOptionCheckDelete: false,
    COLLABORATOR_ERRORS: COLLABORATOR_ERRORS,
    FILE_FLAG_OPTIONS: FILE_FLAG_OPTIONS,
    MASSIVE_UPLOAD_UPGRADE_RESPONSE: MASSIVE_UPLOAD_UPGRADE_RESPONSE,
    e1: 0,
    working: {
      loading: false,
      validating: false,
    },
    flags: {
      continue: true,
      status: 0,
    },
    modal: {
      text: 'Verificación de contenido',
      title: '',
      message: '',
    },
    confirm: {
      value: false,
      title: '',
      show: false,
      description: '',
    },
    noButtons: true,
    headers: [
      {
        text: 'Nombre',
        align: 'left',
        sortable: false,
        value: 'Nombre',
      },
      { text: 'Apellidos', sortable: false, value: 'Apellidos' },
      { text: 'Correo', value: 'Email', sortable: false },
      { text: 'Correo Nuevo', value: 'Email', sortable: false },
      { text: 'Rol', value: 'Rol', sortable: false },
      { text: 'Error', sortable: false, value: 'Error' },
    ],
    headersUpdated: [
      {
        text: 'Nombre',
        align: 'left',
        sortable: false,
        value: 'Nombre',
      },
      { text: 'Apellidos', sortable: false, value: 'Apellidos' },
      { text: 'Correo', value: 'Email', sortable: false },
      { text: 'Correo Nuevo', value: 'updatedEmail', sortable: false },
      { text: 'Rol', value: 'Rol', sortable: false },
      { text: 'Estatus', sortable: false, value: 'status' },
      { text: 'Errores', sortable: false, value: 'status' },
      { text: 'Editar', sortable: false, value: 'status' },
    ],
    errorItems: [],
    correctItems: [],
    updatedCollabs: [],
    totalItemsUpgrade: 0,
    loadingUpgrade: false,
    mails: false,
    report: [],
    /**
     * @type {Array<CollaboratorModel>}
     */
    allCollabs: [],
    /**
     * @type {FILE_FLAG_OPTIONS}
     */
    fileFlagOption: undefined,
    socketRoomUuid: undefined,
    isLocked: false,
    /**
     * @type {MASSIVE_UPLOAD_UPGRADE_RESPONSE}
     */
    uploadUpgradeResponse: {},
    paginationUpgrade: {
      // sortBy: 'NAME',
      descending: false,
      total: 0,
      page: 1,
      rowsPerPage: 50,
    },
    isLoadingCollabs: true,
    modalEditCollab: {
      show: false,
      selectedCollab: undefined,
    },
    totalTicsStep3: 1,
    totalTicsStep4: 0,
    // totalTics: 0,
    currentTicsStep4: 0,
    modalStatistics: {
      show: false,
      fileId: undefined,
    },
    progressTicsStep3: 0,
    progressTicsLoadStep4: 0,
  }),
  methods: {
    getUpdatedOption(option) {
      return this.optionCollabValidated.find((e) => e.value === option)
    },
    getPosssibleErrors(option) {
      if (option === '' || option === undefined) {
        return ''
      }
      const errors = {
        'The updated email would repeat in this branch.':
          'Email repetido en el colegio',
      }

      return errors[option] || 'Error en colaborador'
    },
    importAlways() {
      this.working.validating = true
      this.mailConfirm()
    },
    _resetForm(
      { keepUpdateDeleteChecks = false } = { keepUpdateDeleteChecks: false }
    ) {
      if (keepUpdateDeleteChecks === false) {
        this.collabOptionCheckDelete = false
        this.collabOptionCheckUpdate = false
      }

      this.step2Title = 'Validar datos'
      this.allCollabs = []
      this.updatedCollabs = []
      this.errorItems = []
      this.working.loading = false
      this.e1 = 1
      this.fileFlagOption = undefined
      this.isLocked = false
      this.isLoadingCollabs = true
      this.confirm = {
        value: false,
        title: '',
        show: false,
        description: '',
      }
      this.modalStatistics = {
        show: false,
        fileId: undefined,
      }
      this.progressTicsStep3 = 0
      this.progressTicsLoadStep4 = 0
      this.totalTicsStep3 = 1
      this.totalTicsStep4 = 0
      this.currentTicsStep4 = 0
      this.uploadUpgradeResponse = {}
    },
    async revalidate() {
      this.working.loading = true

      const { collaborators, collaboratorsError, fileError } =
        validateParsedCollaborators(
          this.allCollabs,
          this.errorItems,
          this.roles
        )

      this.allCollabs = collaborators
      this.errorItems = collaboratorsError

      if (collaboratorsError.length === 0) {
        await this.next()
      }
      this.working.loading = false
    },
    async fileLoad(event) {
      this._resetForm({ keepUpdateDeleteChecks: true })
      this.working.loading = true
      try {
        const { collaborators, fileError, collaboratorsError } =
          await loadCollaborator(event.target.files, this.roles)
        this.allCollabs = collaborators
        this.errorItems = collaboratorsError

        if (fileError) {
          this.fileFlagOption = FILE_FLAG_OPTIONS.incorrectFormat
          return
        }

        if (collaboratorsError.length === 0) {
          this.fileFlagOption = FILE_FLAG_OPTIONS.correctFormat
          return
        }

        this.fileFlagOption = FILE_FLAG_OPTIONS.errorOnItems
      } catch (error) {
        console.log(error)
      } finally {
        this.working.loading = false
      }

      // this.processFile(
      //   event.target.files,
      //   event.target.value,
      //   'Colaboradores',
      //   this.roles
      // )
      //   .then((result) => {
      //     this.working.loading = false
      //     if (result == 200 || result == 201) {
      //       this.flags.status = result
      //       this.flags.continue = false
      //     }
      //   })
      //   .catch((err) => {
      //     this.working.loading = false
      //     if (this.excel2jsonFail.length < 15 && err != 403) {
      //       this.flags.status = 201
      //       this.flags.continue = false
      //     } else {
      //       this.flags.status = err
      //       this.flags.continue = true
      //     }
      //   })
    },
    isValidCancelBtn() {
      return this.e1 != 4 || this.isLoadingCollabs != false
      // const isUpdatigCollabs = this.isLoadingCollabs === false
      // const isStep4 = this.e1 !== 4

      // return [isUpdatigCollabs, isStep4].some((e) => e === true)
    },
    isValidBackBtn() {
      const isStep1 = this.e1 === 1
      const isStep3 = this.e1 === 3
      const isStep4 = this.e4 === 4 ? false : true

      return [isStep1, isStep3, isStep4].some((e) => e === true)
    },
    back() {
      const steps = {
        2: () => {
          // this.errorItems = []
          // this.allCollabs = []
          this.e1 = 1
        },
        3: () => (this.e1 = 2),
        4: () => (this.e1 = 3),
      }
      steps[this.e1]()
    },
    isValidLoadBtn() {
      const isLoadingCollabs = this.isLoadingCollabs

      return isLoadingCollabs
    },
    isValidNextBtn() {
      const emptyCollabs = this.allCollabs.length === 0
      const someErrorOnCollabs = this.errorItems.length !== 0 && this.e1 != 1
      const isStep4 = this.e1 === 4
      const invalidFileFormat = this.errorOnFileFormat === true
      const isLocked = this.isLocked === true || this.isLocked === undefined

      return [
        emptyCollabs,
        someErrorOnCollabs,
        isStep4,
        invalidFileFormat,
        isLocked,
      ].some((e) => e === true)
    },
    _dialog(
      {
        show = false,
        title = 'Aviso',
        message = 'Aviso',
        okText = 'ACEPTAR',
      } = {
        show,
        title,
        message,
        okText,
      }
    ) {
      this.dialog.show = show
      this.dialog.title = title
      this.dialog.message = message
      this.dialog.okText = okText
    },
    async next(comeFromStep) {
      const steps = {
        1: async () => {
          if (this.errorItems.length === 0) {
            await this.next(2)
            return
          }

          this.step2Title = 'Errores encontrados'
          this.e1 = 2
          this._dialog({
            show: true,
            title: 'Aviso',
            message:
              'Se han encontrado uno o más errores en el archivo que deseas importar, para continuar con el proceso, asegúrate de corregirlos.',
          })
        },
        2: async () => {
          this.step2Title = 'Verificación de contenido'
          this.e1 = 3

          this.isLocked = await this._isLocked()

          if (this.isLocked === undefined) {
            this._dialog({
              show: true,
              message:
                'El proceso de importación no se ha podido completar, por favor intenta nuevamente.',
            })
            return
          }

          if (this.isLocked === true) {
            this._dialog({
              show: true,
              title: '¡Atención!',
              message:
                'Actualmente se está realizando la carga masiva de colaboradores en tu colegio, por favor espera que el proceso termine para poder continuar.',
            })
            return
          }

          this._dialog({
            show: true,
            title: 'Importante',
            message:
              'A continuación se muestra el listado de los colaboradores y los estatus de cada uno de ellos, verifica la información antes de realizar la carga.',
          })

          // this._unSubscribeWs()
          // this._createRoomUuid()
          // this._subscribeWs()
          const delay = setTimeout(() => {
            this.uploadData()
            clearTimeout(delay)
          }, 500)
        },
        3: async () => {
          await new Promise((res, _) => {
            this.e1 = 4
            res()
          })
        },
      }
      const isDefined = comeFromStep != undefined
      const isTypeNumber = typeof comeFromStep === 'number'
      const isInRange = 4 > comeFromStep > 0

      if (isDefined && isTypeNumber && isInRange) {
        await steps[comeFromStep]()
        return
      }

      await steps[this.e1]()
      // switch (this.e1) {
      //   case 1:
      //     this.e1 = 2
      //     if (this.excel2jsonFail.length > 0) {
      //       this.errorItems = this.excel2jsonFail
      //       this.modal.text = 'Corrección de errores'
      //     } else {
      //       this.errorItems = this.excel2json
      //     }
      //     this.$forceUpdate()
      //     break
      //   case 2:
      //     if (this.excel2jsonFail.length > 0) {
      //       this.working.validating = true
      //       var p = new Promise((resolve, reject) => {
      //         for (var r in this.errorItems) {
      //           this.excel2json.push(this.errorItems[r])
      //         }
      //         this.validateExcelColab(resolve, reject, this.roles)
      //       })
      //         .then((result) => {
      //           this.working.validating = false
      //           if (result == 201) {
      //             this.modal.text = 'Corrección de errores'
      //             this.errorItems = this.excel2jsonFail
      //           } else {
      //             this.modal.text = 'Verificación de contenido'
      //             this.errorItems = this.excel2json
      //           }
      //           this.flags.status = result
      //           this.$forceUpdate()
      //         })
      //         .catch((err) => {
      //           this.working.validating = false
      //         })
      //     } else {
      //       this.working.validating = true
      //       this.mailConfirm()
      //     }
      //     break
      // }
    },
    _sleep(ms = 100) {
      return new Promise((res, _) => {
        const _time = setTimeout(() => {
          res()
          clearTimeout(_time)
        }, ms)
      })
    },
    /**
     * Verificar si la branch esta bloqueada por alguna carga masiva
     * @return {Promise<boolean|undefined>}
     */
    async _isLocked() {
      try {
        const response = await this.$store.dispatch(
          'employee/massiveUploadIsLocked'
        )
        return response
      } catch (error) {
        console.log(error)
        return undefined
      }
    },
    confirmBtn() {
      this.mailConfirm()
    },
    async uploadData() {
      const temp = {
        socket: this.socketRoomUuid,
        updateExisting: this.collabOptionCheckUpdate,
        removeMissing: this.collabOptionCheckDelete,
        collaborators: this.allCollabs.map((e) => ({
          ...e,
          email: e.email === '' ? undefined : e.email,
          updatedEmail: e.updatedEmail === '' ? undefined : e.updatedEmail,
        })),
      }
      this.progressTicsStep3 = 0
      this.isLoadingCollabs = true
      this.totalTicsStep3 = this.allCollabs.length

      try {
        const response = await this.$store.dispatch(
          'employee/massiveUploadUpgrade',
          temp
        )
        const data = response.data
        this.uploadUpgradeResponse = data
        this.modalStatistics.fileId = data.id
        this.totalTicsStep3 =
          data.created + data.updated + data.ignored + data.removed
        this.$forceUpdate()
        // this.totalTicsStep3 =
        //   data.created +
        //   data.removed +
        //   data.updated +
        //   data.skipped +
        //   data.ignored
        // this.totalTicsStep3 =
        //   data.created + data.removed + data.updated + data.ignored
        this._subscribeWsStep4()
        if (this.totalTicsStep3 === 0) {
          this.progressTicsStep3 = 100
          this.isLoadingCollabs = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoadingCollabs = false
      }
    },
    async getUpdatedItems() {
      const params = {
        search: this.searchUpdated,
        status:
          this.optionCollabValidatedSelected === ''
            ? undefined
            : this.optionCollabValidatedSelected,
        size: this.paginationUpgrade.rowsPerPage,
        offset:
          (this.paginationUpgrade.page - 1) *
          this.paginationUpgrade.rowsPerPage,
      }
      this.loadingUpgrade = true
      try {
        const response = await this.$store.dispatch(
          'employee/getItemsMassiveUpload',
          [this.uploadUpgradeResponse.id, params]
        )

        this.updatedCollabs = CollaboratorModel.fromArray(response.data.data)
        this.totalItemsUpgrade = response.data.total
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingUpgrade = false
      }
    },
    _connectWs() {
      this.$socket.connect()
    },
    _createRoomUuid() {
      this.socketRoomUuid = uuidv4()
    },
    _subscribeWsStep4() {
      // this._unSubscribeWs()
      const socketRoom = `${this.uploadUpgradeResponse.id}-collaborator-upgrade-step3`
      console.log('subscribe', socketRoom)
      this.$socket.emit('subscribe', socketRoom)
    },
    _unSubscribeWsStep4() {
      if (this.uploadUpgradeResponse.id === undefined) return
      const socketRoom = `${this.uploadUpgradeResponse.id}-collaborator-upgrade-step3`
      console.log('unsubscribe', socketRoom)
      this.$socket.emit('unsubscribe', socketRoom)
    },
    _subscribeWs() {
      const socketRoom = `${this.socketRoomUuid}-collaborator-upgrade-step2`
      // console.log(socketRoom)
      this.$socket.connect()
      console.log('subscribe', socketRoom)
      this.$socket.emit('subscribe', socketRoom)
      // if (this.uuid) {
      //   var room = this.uuid + '-collaborator-upgrade-step2'
      //   console.log('Connecting & subscribing to ', room)
      //   this.$socket.connect()
      //   this.$socket.emit('subscribe', room)
      //   this.connected = true
      // } else {
      //   console.log('No branch yet')
      // }
    },
    _unSubscribeWs() {
      if (this.socketRoomUuid === undefined) return
      const socketRoom = `${this.socketRoomUuid}-collaborator-upgrade-step2`
      // console.log(socketRoom)
      console.log('unsubscribe', socketRoom)
      this.$socket.emit('unsubscribe', socketRoom)
      this.socketRoomUuid = undefined
    },
    import() {
      this.noButtons = false
      var flag = 0
      var allColabs = []
      for (var c in this.excel2json) {
        var colab = {
          firstName: this.excel2json[c].Nombre,
          lastName: this.excel2json[c].Apellidos,
          password: '12345678a',
          webRole: this.excel2json[c].webRole,
          mail: this.excel2json[c].Correo,
          sendFlag: this.mails,
        }
        allColabs.push(colab)
      }
      var json = JSON.stringify(allColabs) // aqui tienes la lista de objetos en Json
      var obj = JSON.parse(json)
      this.$store
        .dispatch('employee/importColab', obj)
        .then((response) => {
          this.noButtons = true
          flag++
          this.report = response.data.entity
          this.working.validating = false
          this.e1 = 3
          this.flags.status = 200
          this.modal.title = 'Importación exitosa'
          this.modal.message = 'La lista fué importada correctamente'
          for (let r of this.report) {
            if (r.code != 200) {
              this.working.validating = false
              this.e1 = 3
              this.flags.status = 201
              this.modal.title = 'Advertencia'
              this.modal.message =
                'La lista fué importada correctamente, sin embargo existen registros que aún se encuentran erróneos. Puedes descargar el archivo para visualizar con mayor detalle los errores'
            }
          }
        })
        .catch((error) => {
          this.noButtons = true
          var obError = error.data.entity
          console.log(obError)
          this.noButtons = true
          this.working.validating = false
          this.e1 = 3
          this.flags.status = 201
          this.modal.title = 'Advertencia'
          this.modal.message =
            'Hubo un problema al importar la lista, intente de nuevo, por favor.'
        })
    },
    // download() {
    //   var content = []
    //   for (const [index, item] of this.report.entries()) {
    //     content.push({
    //       Nombre: item.entity.firstName,
    //       Apellidos: item.entity.lastName,
    //       Correo: item.entity.mail,
    //       Estado: item.message,
    //     })
    //   }
    //   this.downloadReport(content)
    // },
    mailConfirm() {
      this.confirm.description = '¿Desea enviar correo a los colaboradores?'
      this.confirm.value = true
      this.confirm.title = 'Confirmación'
      this.confirm.show = true
    },
    desitionLink(val) {
      this.confirm.value = false
      this.confirm.show = false
      this.mails = val
      // this.import()

      // this._subscribeWsStep4()
      this.modalStatistics.show = true
    },
    close() {
      this._resetForm()
      this._unSubscribeWs()
      this._unSubscribeWsStep4()
      // this.$emit('correct', this.correctItems)
      this.$emit('input', false)
      // this.correctItems = []
      // this.e1 = 1
      // this.excel2json = []
      // this.excel2jsonFail = []
      // this.badlist = false
      // this.errorCode = 0
      // this.flags.continue = true
      // this.flags.status = 0
      try {
        document.getElementById('file_csv_colab').value = ''
      } catch (error) {
        console.log(error)
      }
    },
    editCollab(collab) {
      this.modalEditCollab.show = true
      this.modalEditCollab.selectedCollab = new CollaboratorModel(collab)
    },
    onUpdatedCollab(collab) {
      if (collab === undefined) return
      this.updatedCollabs = this.updatedCollabs.map((e) =>
        e.id === collab.id ? new CollaboratorModel(collab) : e
      )
    },
    onTotal(total) {
      this.totalTicsStep4 = total
    },
    async onCompleteUpdateCollabs() {
      await this.next(3)
      await this._sleep(500)
      const temp = {
        idCollaboratorUpgrade: this.uploadUpgradeResponse.id,
        sendFlag: this.mails,
      }

      this.isLoadingCollabs = true
      try {
        const response = await this.$store.dispatch(
          'employee/massiveUploadComplete',
          temp
        )

        const data = response.data
        this.totalTicsStep4 =
          data.created + data.removed + data.updated + data.skipped
        if (this.totalTicsStep4 === 0) {
          this.progressTicsLoadStep4 = 100
          this.isLoadingCollabs = false
        }
      } catch (error) {
        console.log(error)
        this.errorOnStep4 = true
      } finally {
        this.isLoadingCollabs = false
      }
    },
  },
  watch: {
    value: function () {
      if (this.value === true) {
        this._unSubscribeWs()
        this._createRoomUuid()
        this._subscribeWs()
      }
      if (this.value === false) {
        this.close()
        this._unSubscribeWs()
      }
    },
    collabOptionCheckDelete: function () {
      if (this.collabOptionCheckDelete === true) {
        this._dialog({
          show: true,
          title: 'Confirmación',
          message:
            'Esta opción eliminará a los colaboradores que ya están registrados en el colegio.',
          okText: 'Entendido',
        })
      }
    },
  },
  sockets: {
    connect(evt) {
      console.log('Connected', evt)
    },
    disconnect(evt) {
      console.log('Disconnected', evt)
    },
    reconnect() {
      console.log('Reconnected')
      this._subscribeWs()
    },
    message(notification) {
      // console.log(notification)
      if (this.e1 === 3) {
        this.updatedCollabs.push(new CollaboratorModel(notification))
        this.progressTicsStep3 =
          (this.updatedCollabs.length * 100) / this.totalTicsStep3

        if (this.progressTicsStep3 === 100) {
          this.getUpdatedItems()
          this.isLoadingCollabs = false
        }
      }

      if (this.e1 === 4) {
        // console.log(notification)
        this.currentTicsStep4 = this.currentTicsStep4 + 1
        this.progressTicsLoadStep4 =
          (this.currentTicsStep4 * 100) / this.totalTicsStep4
        if (this.progressTicsLoadStep4 === 100) {
          this.isLoadingCollabs = false
        }
      }

      //   ;(notification.parents || []).forEach((parent) => {
      //     parent.stdId = notification.id
      //   })
      //   if (this.step == 3) {
      //     this.contentT.push(notification)
      //     if (this.progress < 100) {
      //       this.progress = (this.contentT.length / this.excel2json.length) * 100
      //     }
      //   }
      //   if (this.step == 4) {
      //     this.wsEst.push(notification)
      //     if (this.progressStd < 100) {
      //       this.progressStd = (this.wsEst.length / this.excel2json.length) * 100
      //     }
      //   }
    },
  },
}
</script>

<style>
.form-csv input {
  position: absolute;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 190px;
  outline: none;
  opacity: 0;
}

.csv-text {
  margin-top: 10%;
}

.form-csv {
  height: 200px;
  border: 4px dashed #c6c7c7;
  background-color: #eceff0;
}

/* 
  THIS STYLE IS NEEDEED TO BE GLOBAL
  CAUSE THE FIRST ELEMENT ON THE TABLE
  DOES NOT RENDER DATA BINDING WELL
  SO LET THIS CSS STYLE BE
 */
.custom_field_error_massive_upload {
  position: relative;
}
/* 
  THIS STYLE IS NEEDEED TO BE GLOBAL
  CAUSE THE FIRST ELEMENT ON THE TABLE
  DOES NOT RENDER DATA BINDING WELL
  SO LET THIS CSS STYLE BE
 */
.custom_field_error_massive_upload::before {
  font-weight: bold;
  color: orangered;
  content: attr(data-error);
  top: -4px;
  position: absolute;
  left: 30px;
}
</style>

<style scoped>
::v-deep table.v-table thead th,
::v-deep table.v-table tbody td {
  text-align: left !important;
  width: 250px;
  min-width: 250px;
}
.form-csv {
  height: 35vh;
  border: 4px dashed #c6c7c7;
  background-color: #eceff0;
}
._relative {
  position: relative;
}
._relative i {
  position: absolute;
  right: 0;
  width: min-content;
  font-size: 20px;
}
.custom_error {
  background-color: #fbdfde !important;
  width: 100% !important;
  border-radius: 3px;
}
._custom_full_width {
  width: 100% !important;
}
#app.theme--dark .custom_error {
  background-color: #ff504a !important;
}
.bar {
  background: linear-gradient(to right, #ef565b, #512e6f);
  height: 20px;
  width: 20px;
  border-radius: 9px;
  text-align: center;
}
.spb {
  padding: 4px 5px;
  color: #fff;
  /* font-size: 0.7em; */
}
</style>
